import MuiGrow, { type GrowProps } from "@mui/material/Grow";

export type { GrowProps };

export function Grow(props: GrowProps) {
  return <MuiGrow {...props} />;
}
